import { StatePersistor } from "./../utils/StatePersistor";
import ServerRequestWrapper from "./ServerRequestWrapper";
import { API_PATH } from "../utils/Constants";

interface IRequest<T> {
  method: string;
  headers?: {};
  run: (method: string, data: {} | undefined, headers: {}) => Promise<T>;
  data?: {} | undefined;
}

class EndpointsBase {
  protected server: ServerRequestWrapper;

  constructor(baseUri: string | undefined = API_PATH) {
    this.server = new ServerRequestWrapper(baseUri + "/api/");
  }

  protected _getAuthHeader(
    operatorID?: number | null,
    workstationID?: number,
    companyID?: number,
    branchID?: number
  ) {
    return {
      AuthOperatorID:
        operatorID ||
        StatePersistor.select("operatorID") ||
        StatePersistor.getValue("-operatorID") ||
        StatePersistor.getValue("operatorID") ||
        StatePersistor.getValue("review-operatorID"),
      WorkstationID:
        workstationID ||
        StatePersistor.select("workstationID") ||
        StatePersistor.getValue("-workstationID") ||
        StatePersistor.getValue("workstationID") ||
        StatePersistor.getValue("review-workstationID"),
      CompanyID:
        companyID ||
        StatePersistor.select("companyID") ||
        StatePersistor.getValue("-companyID") ||
        StatePersistor.getValue("companyID"),
      BranchID:
        branchID ||
        StatePersistor.select("branchID") ||
        StatePersistor.getValue("-branchID") ||
        StatePersistor.getValue("branchID"),
      SortID:
        StatePersistor.select("sortID") ||
        StatePersistor.getValue("-sortID") ||
        StatePersistor.getValue("sortID"),
      SortType:
        StatePersistor.select("sortType") ||
        StatePersistor.getValue("-sortType") ||
        StatePersistor.getValue("sortType"),
      ConveyorID:
        StatePersistor.select("conveyorID") ||
        StatePersistor.getValue("-conveyorID") ||
        StatePersistor.getValue("conveyorID"),
    };
  }

  protected _sendRequest<T>(request: IRequest<T>) {
    return request.run(request.method, request.data, request.headers || {}).catch((error: any) => {
      return this._handleError(error);
    });
  }
  private _handleError(error: any) {
    throw error;
  }
}

export default EndpointsBase;
